function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M378.657 749.623c-151.575-7.832-322-100.58-350.61-270.186C-26.472 156.222 149.569 8.26 387.283 19.702c173.402-18.58 319.394 121.583 353.27 297.878-5.387 193.241-88.771 437.791-359.021 432.044z",
  stroke: "currentColor",
  strokeMiterlimit: 10
});

function Svg001(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 759 768",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNzU5IDc2OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zNzguNjU3IDc0OS42MjNjLTE1MS41NzUtNy44MzItMzIyLTEwMC41OC0zNTAuNjEtMjcwLjE4NkMtMjYuNDcyIDE1Ni4yMjIgMTQ5LjU2OSA4LjI2IDM4Ny4yODMgMTkuNzAyIDU2MC42ODUgMS4xMjIgNzA2LjY3NyAxNDEuMjg1IDc0MC41NTMgMzE3LjU4Yy01LjM4NyAxOTMuMjQxLTg4Ljc3MSA0MzcuNzkxLTM1OS4wMjEgNDMyLjA0NHoiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPC9zdmc+";
export { Svg001 as ReactComponent };